<template>
    <i v-tooltip="tooltipText">
        <fa icon="paper-plane" style="color: #808080;"/>
    </i>
</template>

<script>
import Tooltip from 'primevue/tooltip'

export default {
    name: 'sentNormalBulkPaperIcon',
    props: ['tooltipText'],
    emits: [],
    directives: {
        'tooltip': Tooltip,
    },
}
</script>

<style scoped>
</style>


